import { render, staticRenderFns } from "./VsInputHint.vue?vue&type=template&id=238a445e&scoped=true&"
import script from "./VsInputHint.vue?vue&type=script&lang=js&"
export * from "./VsInputHint.vue?vue&type=script&lang=js&"
import style0 from "./VsInputHint.vue?vue&type=style&index=0&id=238a445e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238a445e",
  null
  
)

export default component.exports